import { Component, Input, OnInit,Directive, ElementRef, HostListener, DebugElement, AfterViewInit  } from '@angular/core';
import { APIService } from '../../api.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { debug } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { from, Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from '../../services/data.service';
// @Directive({
//   selector: '[appTitleCase]'
// })

@Component({
  selector: 'app-task-entry',
  templateUrl: './task-entry.component.html',
  styleUrls: ['./task-entry.component.scss']
})

export class TaskEntryComponent implements OnInit, AfterViewInit {

  public minDate: Date = new Date();

  changingValue: Subject<boolean> = new Subject();
  @Input() mdlRef: any;
  @Input() projectList: Array<any> = [];
  @Input() modalHeader: any;

  constructor(private modalService: NgbModal,private apiService: APIService,private SpinnerLoader: NgxSpinnerService, private commonService: CommonService, private el: ElementRef, public dataSer: DataService) { }
  
  // @HostListener('blur') onBlur() {
  //   if (this.el.nativeElement.value) {
  //     const arr: string[] = this.el.nativeElement.value.split('');
  //     arr[0] = arr[0].toUpperCase();
  //     this.el.nativeElement.value = arr.join('');
  //  }
  // }
  
  isShowDis : boolean = false;
  isShowTag : boolean = false;
  tagList: Array<any> = [];
  executiveName: any = [];
  executiveList: any = [];
  tblJ: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  isUserShow: boolean = false
  
  tskDataForMe: any = [];
  tskDlgtDataForDele: any = [];
  userListID: number = 0;
  selProjInfo:any = {};
  
  objTaskEntry: any = {
    task: '',
    detail: '',
    statusID: 0,
    priorityID: 1,
    taskDate: new Date(),
    doneDate: new Date(),
    toUserID : 0,
    toUserName: '',
    toUserEmail: '',
    replyTo: '',
    fromUserName: '',
    projectID: 0,
    projectName: '',
    projectStageID: 0,
    projectStageName: ''
  }

  data: any = {
    description: '',
    tag: '',
    taskDate: new Date()
  }
  
  modalReference: any;
  closeResult: any;
  userList: Array<any> = [];
  projectStageList: Array<any> = [];

  isTask: boolean = false;
  UserIDM: any = 0;
  userID: any = 0;
  search: any = '';
  assignedUserID: number = 0;
  isInboxEntry: boolean = false;
  taskParam: any = this.commonService.GetParam('T');
  showAsPage: boolean = false;
  innerWidth: any;
  isMobileView: boolean = false;

  agnERPRight: any = {
    EnblProjects: false
  }

  showProjectSelection: boolean = false;

  ngOnInit(): void {
    if(this.taskParam) {
      if(this.taskParam == 1) {
        this.isInboxEntry = true;
      }
      else if(this.taskParam == 2) {
        this.isInboxEntry = false;
      }
      this.showAsPage = true;
      this.modalHeader = 'Create Task';
    }
    

    var jarvis = this.apiService.getCookie("Jarvis");
        if (jarvis) {
            this.jarvisData = JSON.parse(jarvis);
            this.objTaskEntry.toUserID = this.jarvisData[0].UserID
            this.objTaskEntry.toUserName = this.jarvisData[0].UserName
            this.objTaskEntry.fromUserName = this.jarvisData[0].UserName;
        }

        let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
            this.UserIDM = this.agencyData[0].UserID
        }

        let erpAgn: any = this.apiService.getCookie("ERP_Agn");
        if (erpAgn) {
            erpAgn = JSON.parse(erpAgn);
            if (erpAgn.length > 0) {
                this.agnERPRight.EnblProjects = erpAgn[0].EnblProjects;
            }
        }

        this.isUserShow = this.modalHeader == 'Enter Task for Me' ? false : true; 

        let users = this.apiService.getCookie('J');
        if(users){
          var userID = this.jarvisData[0].UserID;
          this.userList = JSON.parse(users);
          this.userList = this.userList.sort((a: any, b: any) => a.Name.localeCompare(b.Name));
          let tempList = $.grep(this.userList, function (o: any) { return o.UserID == userID });
          if(tempList.length > 0){
            this.userListID = tempList[0].UserID;
            if(this.isInboxEntry) {
              this.assignedUserID = tempList[0].UserID;
            }
            this.objTaskEntry.replyTo = tempList[0].Email;
          }
        }

        if (this.selProjInfo) {
          this.objTaskEntry.projectID = this.selProjInfo.projectID;
          this.objTaskEntry.projectName = this.selProjInfo.projectName;
          this.objTaskEntry.projectStageID = this.selProjInfo.projectStageID;
          this.objTaskEntry.projectStageName = this.selProjInfo.projectStageName;
        }

        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1000) {
            this.isMobileView = true;
        }

        this.projectList = this.projectList.filter((project: any) => {
            const stages = project?.Stages ? JSON.parse(project.Stages) : [];
            const activeStageCnt = stages.filter((stage: any) => stage.hasOwnProperty('SDT')).length;
            return activeStageCnt > 0 ? true : false;
        })
        
  }

  ngAfterViewInit(): void {
    if (!this.selProjInfo.hasOwnProperty('projectID')) {
      this.objTaskEntry.projectStageID = 0;
      this.objTaskEntry.projectID = 0;
    }
  }

  closeModel(action : string) {
    this.mdlRef.close(action); 
  }

   //tag Entry
   tagEntry = () => {
    var flag = false;
    if (this.tagList) {
      for (var i = 0; i < this.tagList.length; i++) {
        if (this.data.tag.toUpperCase() == this.tagList[i].toUpperCase()) {
          flag = true
          break;
        }
      }
    }
    if (!flag) {
      this.tagList.push(this.data.tag)
      this.data.tag = '';
    }
    else {
      alert('This tag already exists.');
      this.data.tag = '';
    }

  }

   //remove tag from search
   removeTagSearch = (index: any) => {

    this.tagList.splice(index, 1)

  }

  changeStatus(statusID: number){
      this.objTaskEntry.statusID = statusID;
  }

  changePriority(priorityID: number){
    this.objTaskEntry.priorityID = priorityID;
}

 //save - save new task
 save() {
  //Validation
  if (this.objTaskEntry.task == "") {
      this.apiService.successAlert("Please enter the task.");
      return;
  }

  else {
    var tempData = [{
      'TaskID': 0,
      'Task': this.objTaskEntry.task,
      'Detail': this.objTaskEntry.detail,
      'StatusID': this.objTaskEntry.statusID,
      'Priority': this.objTaskEntry.priorityID,
      'ToUserID': this.objTaskEntry.toUserID ? this.objTaskEntry.toUserID : 0,
      'ToUserName': this.objTaskEntry.toUserName ? this.objTaskEntry.toUserName : '',
      'Tags': '',
      'ExpCompletionDT': new Date(this.objTaskEntry.taskDate).customFormat("#DD#-#MMM#-#YY#"),
      'StatusNote': '' ,
      'DoneDT': this.objTaskEntry.statusID == 3 ? new Date(this.objTaskEntry.doneDate).customFormat("#DD#-#MMM#-#YY#") : null,
      'DoneUserID': this.objTaskEntry.statusID == 3 ? this.objTaskEntry.toUserID : 0,
      'FromUserName': this.objTaskEntry.fromUserName,
      'ToUserEmail': this.objTaskEntry.toUserEmail,
      'ChangeID': 0,
      'OldUserName': '',
      'OldToUserEmail': '',
      'ReplyTo': this.objTaskEntry.replyTo,
      'projectID': this.objTaskEntry.projectID ? this.objTaskEntry.projectID : 0,
      'projectStageID': this.objTaskEntry.projectStageID ? this.objTaskEntry.projectStageID : 0
  }]
      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'set',
          moduleID: 28,
          data: JSON.stringify(tempData)
      }];
      this.apiService.sendChange(myParams, this.successVchrEntry.bind(this), this.failureResp.bind(this));
  }
}

//successVchrEntry - success voucher entry handler
successVchrEntry(res: any) {
  this.SpinnerLoader.hide();
  if (res.error) {
  }
  else {
      let tmpData = JSON.parse(res.updatePackage).Table[0];
      if (tmpData.ErrCode != -1) {
          alert(tmpData.ErrMsg);
          return;
      }
      else {
          const isLive = this.apiService.fn_isLiveURL();
          if (this.selProjInfo.projectStageName && this.selProjInfo.projectName) {
            // let tskEntryObj = {projTaskAdded: true}
            // this.dataSer.updateTaskEntryData(tskEntryObj);
          }
          else {
            if(this.jarvisData[0].UserID == this.objTaskEntry.toUserID){
              this.apiService.successAlert('Task added.');
              window.location.href = (isLive ? '/ERP': '') + "/Tasks?T=1";
            }
            else {
              this.apiService.successAlert('Task assigned.');
              window.location.href = (isLive ? '/ERP': '') + "/Tasks?T=2";
            }
          }
          this.resetAllData();
          //Get Data from Entry for M
          var cookieTaskData = this.apiService.getCookie('tsk');
          if(cookieTaskData){
            this.tskDataForMe = JSON.parse(cookieTaskData);
          }
          this.closeModel("Done");
      }
  }
}

//failureResp - failure handler
failureResp(res: any) {
  this.SpinnerLoader.hide();
  if (res.error) {
  }
  else {
      alert(res.message);
  }
}

resetAllData(){
  this.objTaskEntry = {
    task: '',
    detail: '',
    statusID: 0,
    priorityID: 1,
    taskDate: new Date(),
    toUserID : 0,
    toUserName: '',
    toUserEmail: '',
    projectID: 0,
    projectStageID: 0
  }
}

//selectExe() - select User
selectExeChane(){
  let userID = this.assignedUserID;
  var selectedUsere = $.grep(this.userList, function(o: any){ return o.UserID == userID });
  if(selectedUsere.length > 0){
    this.objTaskEntry.toUserID = selectedUsere[0].UserID;
    this.objTaskEntry.toUserName = selectedUsere[0].Name;
    this.objTaskEntry.toUserEmail = selectedUsere[0].Email;
  }
}

//selectProject() - select Project
selectProjectChange(){
  let projectID = this.objTaskEntry.projectID;
  if (this.objTaskEntry.projectID == 0) {
    this.projectStageList = [];
    return;
  }
  
  var selectedStage = $.grep(this.projectList, function(o: any){ return o.JobID == projectID });
  
  if(selectedStage.length > 0){
    var projectStageListData = JSON.parse(selectedStage[0].Stages);
    projectStageListData = projectStageListData.filter( (item: any) => item.hasOwnProperty('SDT'));
    this.projectStageList = $.grep(projectStageListData, function(o: any){ return o.SDT != ''});
  }
}

  selectExe(content:any){ 
      this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'exceChange', backdrop: 'static', keyboard: false });
      this.modalReference.result.then((result: any) => {
         if (result) {

         }
      });
  }

  public getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public closeModal() {
      this.modalReference.close();     
  }

  backToHomeBtn() {
    this.SpinnerLoader.show();
    window.location.href = "https://biziverse.com/main.html#/home";
  }

  //User List Color
  changeColorUserList(ind: any, userID: number){
    debugger
    var clr = ""    
    clr = userID == this.objTaskEntry.toUserID ? 'bz-drkBlueBtn-lb-active' : 'bz-drkBlueBtn-lb';
    return clr;

    switch(ind) { 
      case 0: { 
        clr = userID == this.objTaskEntry.toUserID ? 'activeOrange' : 'orangeBadge'
         break; 
      } 
      case 1: {
        clr = userID == this.objTaskEntry.toUserID ? 'activeYellow' : 'yellowBadge'
        break; 
      } 
      case 2: { 
        clr = userID == this.objTaskEntry.toUserID ? 'activeGreen' : 'greenBadge'
         break; 
      } 
      case 3: { 
        clr = userID == this.objTaskEntry.toUserID ? 'activeTeal' : 'tealBadge'
         break; 
      } 
      case 4: { 
        clr = userID == this.objTaskEntry.toUserID ? 'activeBlue' : 'blueBadge'
         break; 
      } 
      case 5: { 
        clr = userID == this.objTaskEntry.toUserID ? 'activedarkblue' : 'darkBlueBadge'
         break; 
      } 
      case 6: { 
        clr = userID == this.objTaskEntry.toUserID ? 'activeBrown' : 'brownBadge'
         break; 
      } 
    
   }
   return clr; 
  }

// first later capital


}
